<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Documents</h2>
    <v-divider></v-divider>
    <br />
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt100">
        <v-list-tile>
          <v-flex sm4>
            <h5>National ID Card Front Page :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.nid_front_page"
              :href="`${document_Url}/${documents.nid_front_page}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <!-- <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.nid_front_page}`"
                
              /> -->
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.nid_front_page}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>National ID Card Back Page :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.nid_back_page"
              :href="`${document_Url}/${documents.nid_back_page}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.nid_back_page}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Salary Certificate :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.salary_certificate"
              :href="`${document_Url}/${documents.salary_certificate}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.salary_certificate}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Utility Bill :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.electricity_bill"
              :href="`${document_Url}/${documents.electricity_bill}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.electricity_bill}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Bank Statement First Page :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.bank_statement_first_page"
              :href="`${document_Url}/${documents.bank_statement_first_page}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.bank_statement_first_page}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Bank Statement Last Page :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.bank_statement_last_page"
              :href="`${document_Url}/${documents.bank_statement_last_page}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.bank_statement_last_page}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Additional Document 1 :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.additional_document1"
              :href="`${document_Url}/${documents.additional_document1}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.additional_document1}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Additional Document 2 :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.additional_document2"
              :href="`${document_Url}/${documents.additional_document2}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.additional_document2}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 class="divWidthHeight mt20">
        <v-list-tile>
          <v-flex sm4>
            <h5>Additional Document 3 :</h5>
          </v-flex>
          <v-flex sm8>
            <a
              v-if="documents.additional_document3"
              :href="`${document_Url}/${documents.additional_document3}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ImgLazyLoad
                class="imageHeightWidth"
                :src="`${document_Url}/${documents.additional_document3}`"
              />
            </a>
            <v-list-tile-content v-else>Not uploaded</v-list-tile-content>
          </v-flex>
        </v-list-tile>
      </v-flex>
    </v-layout>
  </v-list>
</template>
<script>
  import ImgLazyLoad from "@/components/ImgLazyLoad";
  export default {
    components: { ImgLazyLoad },
    props: ["documents"],
    data() {
      return {
        document_Url: process.env.VUE_APP_DOCUMENT_URL,
      };
    },
  };
</script>
<style scoped>
  .divWidthHeight {
    width: 200px;
    height: 200px;
  }
  .imageHeightWidth {
    max-width: 200px;
    height: auto;
    max-height: 200px;
  }
  .mt100 {
    margin-top: 100px;
  }

  .mt20 {
    margin-top: 20px;
  }
</style>
